<template>
    <div>
        <div class="bidderMeta font-6 tableText displayNameMargins"
             :class="{'missingConfiguration': missingConfiguration}">
            <span>
                <v-popover trigger="hover"
                           placement="left"
                           class="missingConfigPopOverWrap"
                           popoverInnerClass="tooltip-inner"
                           popoverBaseClass="vueTooltip"
                           popoverArrowClass="tooltip-arrow"
                           v-show="missingConfiguration">
                    <div class="missingConfigPopOver">
                        <IconBase width="12" height="12" :iconColor="missingConfigColor" iconName="wrenchIcon"
                                  v-show="missingConfiguration" class="missingConfig" />
                    </div>
                    <template slot="popover">
                        Input missing configurations on the
                        <a :href="'/partners/monetize/mediation/setup/app/' + appKey" v-once>
                            SDK Networks
                        </a> page
                    </template>
                </v-popover>
                {{providerDisplayName}}
            </span>
            <span v-if="(Array.isArray(activeCountries) && !isAllCountries) || showChinaCountriesTooltip"
                  class="countriesTooltip">
              <IconBase width="11" height="12" :iconColor="globeColor" iconName="countryIcon"
                      v-tooltip="{content: activeCountriesTooltip}"
                      class="activeCountries"/>
            </span>

        </div>
        <span class="font-7 tableDataMetric" :class="{'disabled': ecpmComputed.disabled}">
            {{ ecpmComputed.val }}
        </span><span class="font-7 tableDataMetric" :class="{'disabled': impressionsComputed.disabled}">
            {{ impressionsComputed.val }}
        </span><span class="font-7 tableDataMetric" :class="{'disabled': revenueComputed.disabled}">
            {{ revenueComputed.val }}
        </span><span class="font-7">
            <PercentBar class="sov-data"
                        :val="sov.val"
                        :maxVal="sov.maxVal"
                        :fillColorAlpha="0.1"
                        noValueText="N/A"
                        :filledSpaceColor="consts.COLORS.PRIMARY_500"
            ></PercentBar>
        </span>
    </div>
</template>

<script>
import consts from 'services/metaData/consts';
import decimalFormat from 'services/filters/decimalFormat';
import IconBase from 'components/IconBase.vue';
import PercentBar from 'components/percentBar/PercentBar.vue';
import Countries from '../../services/countries';

export default {
    name: 'BidderInstance',
    components: { PercentBar, IconBase },
    data() {
        return {
            consts
        };
    },
    props: {
        providerDisplayName: {
            type: String,
            required: true
        },
        ecpm: {
            type: Number,
            required: true
        },
        impressions: {
            type: Number,
            required: true
        },
        revenue: {
            type: Number,
            required: true
        },
        sov: {
            val: Number,
            maxVal: Number
        },
        appKey: {
            type: String,
            required: true
        },
        missingConfiguration: Boolean,
        showChinaCountriesTooltip: Boolean,
        activeCountries: {
            type: [Array, String]
        },
        isAllCountries: {
            type: Boolean
        }
    },
    computed: {
        missingConfigColor() {
            return consts.COLORS.NEGATIVE_500;
        },
        impressionsComputed() {
            if (this.impressions) {
                return {
                    val: decimalFormat(this.impressions),
                    disabled: false
                };
            }
            return {
                val: 'N/A',
                disabled: true
            };
        },
        ecpmComputed() {
            if (this.ecpm) {
                return {
                    val: `$ ${decimalFormat(this.ecpm)}`,
                    disabled: false
                };
            }
            return {
                val: 'N/A',
                disabled: true
            };
        },
        globeColor() {
            return consts.COLORS.LIGHT_700;
        },
        revenueComputed() {
            if (this.revenue) {
                return {
                    val: `$ ${decimalFormat(this.revenue)}`,
                    disabled: false
                };
            }
            return {
                val: 'N/A',
                disabled: true
            };
        },
        activeCountriesTooltip() {
            return Countries.activeCountriesTooltip(
                this.isAllCountries,
                this.activeCountries,
                this.showChinaCountriesTooltip
            );
        }
    },
    filters: {
        decimalFormat
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";

    .tableText {
        color: $dark-300;
    }

    .displayNameMargins {
        margin-left: 8px;
    }

    .sov-data {
        display: inline-block;
        width: 100%;
    }

    .missingConfig {
        margin-right: 8px;
        height: 24px;
        width: 24px;
        display: inline-block;
        background-color: $negative-100;
        border-radius: 100%;
        vertical-align: middle;

        /deep/ svg {
            display: block;
            margin-top: 6px;
            margin-left: 6px;
        }
    }

    .missingConfiguration {
        color: $negative-500;
    }

    .missingConfigPopOver {
        width: 30px;
    }

    .missingConfigPopOverWrap {
        display: inline-block;
    }

    .bidderMeta {

        display: grid;
        justify-content: stretch;
        grid-template-columns: auto auto;
        grid-column-gap: 5px;
    }
    .countriesTooltip{
        padding-top: 1px;
        margin-bottom: -1px;
        width: 12px;
    }

    .disabled {
        color: $light-800;
    }
</style>
